import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Lock, Sparkles, Wallet, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRIMARY_CTA, packageIncludes } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  const firstBonusIndex = packageIncludes.findIndex(item => item.kind === 'bonus');
  return <section id="pricing" className="py-20 px-4 bg-sage-50 relative" data-id="element-183" data-mp="1naaltis4es29">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-184" data-mp="1s8lwfvq8p6lj">
        <div className="text-center mb-10" data-id="element-185" data-mp="1x8qcjkn8jzb8">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-3 text-forest uppercase" data-id="element-186" data-mp="1x9rm1kolsdqu">
            Your Complete <span className="text-leaf" data-id="element-187" data-mp="227b3sukif8nj">Hydroponics Grower Ready</span> Package
          </h2>
          <p className="text-charcoal/80 text-sm md:text-base" data-id="element-188" data-mp="2w0fwv5hgc05">
            Everything You Need to Build, Grow, Monitor & Troubleshoot With More Confidence
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-sage-200 border-2 border-leaf rounded-3xl p-1 relative shadow-xl shadow-forest/10" data-id="element-189" data-mp="1mhq1cco5bkhw">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-forest-700 font-bold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap z-10" data-id="element-190" data-mp="17tli97l6l6yl">
            <Sparkles size={14} data-id="element-191" data-mp="20emrsd0cqzy9" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-192" data-mp="1vg1t4i0r0obx">
            <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-md h-auto mx-auto mb-6" loading="lazy" data-id="element-193" data-mp="1rgj7tl50mb8k" />

            <p className="text-sm font-bold tracking-widest text-leaf mb-3" data-id="element-194" data-mp="g02upygxo6ov">YOU RECEIVE</p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-sage-50 border border-sage-200 rounded-xl p-4" data-id="element-195" data-mp="hh8bpj090da6">
              {packageIncludes.map((item, itemIndex) => <React.Fragment key={item.label} data-id="element-196" data-mp="7jlrqi43dvjc" data-mpi={itemIndex}>
                  {itemIndex === firstBonusIndex && <li className="pt-2 text-xs font-bold tracking-widest text-forest" data-id="element-197" data-mp="ciev3hpo065s">PLUS:</li>}
                  <li className="flex items-start gap-2 text-sm text-charcoal" data-id="element-198" data-mp="3uw4pgw4biqon">
                    {item.kind === 'bonus' ? <Gift size={16} className="text-gold shrink-0 mt-0.5" data-id="element-199" data-mp="3jjpo7ug303j" /> : <Check size={16} className="text-leaf shrink-0 mt-0.5" data-id="element-200" data-mp="3l01nbq9gus1p" />}
                    <span data-id="element-201" data-mp="3py31bws1c16b">{item.label}</span>
                  </li>
                </React.Fragment>)}
            </ul>

            <div className="mb-6" data-id="element-202" data-mp="3c067h84yu8vc">
              <p className="text-sm text-charcoal/60 mb-1" data-id="element-203" data-mp="3fznc5zckj1zg">
                REGULAR VALUE: <span className="line-through" data-id="element-204" data-mp="2xatm57n608an">$105 USD</span>
              </p>
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-205" data-mp="2xcy06ies2non">
                <span className="text-2xl md:text-3xl text-charcoal/70" data-id="element-206" data-mp="2sdux33icyrjb">TODAY:</span>
                <span className="text-4xl md:text-5xl font-extrabold tracking-tight text-leaf" data-id="element-207" data-mp="36dcm9jzkg6t7">
                  $27 USD
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-208" data-mp="3g8xl599c8qyq">
              {PRIMARY_CTA}
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-charcoal/60" data-id="element-209" data-mp="3p4dhpy1h9k80">
              <span className="flex items-center gap-1.5" data-id="element-210" data-mp="3l31rbqas4uyr">
                <Lock size={12} className="text-leaf" data-id="element-211" data-mp="2vuh5kb6hdwh" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-212" data-mp="3u2f3wru79znp">
                <Zap size={12} className="text-leaf" data-id="element-213" data-mp="hy2kmvi9ruyo" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-214" data-mp="hw9nc6tjqn3c">
                <Wallet size={12} className="text-leaf" data-id="element-215" data-mp="lyd0czvv5zqq" /> One-Time Payment
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}